import { ATTRIBUTION_MODEL_OPTIONS } from 'constants/common';
import { useState, MouseEvent } from 'react';
import { useStoreContext } from 'store';
import { setStoreState } from 'store/actions';
import { alpha, Box, Button, Popover, Tooltip } from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import SelectFilter from '../Filters/SelectFilter';

interface Props {
  inline?: boolean;
}

const Filters = (props: Props): JSX.Element => {
  const { inline } = props;

  const {
    state: { attributionModel },
    dispatch,
  } = useStoreContext();

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  if (inline) {
    return (
      <>
        <Tooltip title="Attribution model" enterDelay={500}>
          <Button
            onClick={handleClick}
            variant="contained"
            color="primary"
            sx={(theme) => ({
              whiteSpace: 'nowrap',
              boxShadow: 'unset',
              color: theme.palette.primary.main,
              background: alpha(theme.palette.primary.main, 0.1),
              '&:hover': {
                boxShadow: 'unset',
                color: theme.palette.primary.main,
                background: alpha(theme.palette.primary.main, 0.2),
              },
            })}
            endIcon={<ArrowDropDown />}
          >
            {attributionModel}
          </Button>
        </Tooltip>
        <Popover
          id="attribution-model-popover"
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <Box
            sx={{
              maxHeight: '60vh',
              width: '30vw',
              overflowY: 'scroll',
              overflowX: 'hidden',
            }}
          >
            <SelectFilter
              inline
              label="Attribution model"
              options={ATTRIBUTION_MODEL_OPTIONS}
              value={attributionModel}
              onChange={(value) => {
                dispatch(setStoreState({ attributionModel: value as any }));
                handleClose();
              }}
            />
          </Box>
        </Popover>
      </>
    );
  }

  return (
    <SelectFilter
      label="Attribution model"
      options={ATTRIBUTION_MODEL_OPTIONS}
      value={attributionModel}
      onChange={(value) =>
        dispatch(setStoreState({ attributionModel: value as any }))
      }
    />
  );
};

export default Filters;
